<template>
    <CollectionSection
        :collection-type-id
        :section-title
        :color-theme="colorTheme"
    />
</template>

<script setup lang="ts">
import type { FlexibleCollectionsBlockFragment } from '~/types/craft-schema';

const props = defineProps<FlexibleCollectionsBlockFragment>();

const collectionTypeId = computed(() => {
    if (
        props.collectionType &&
        props.collectionType.length > 0 &&
        props.collectionType[0]?.__typename === 'collectionType_Category'
    ) {
        return props.collectionType[0].id;
    }

    return null;
});
</script>
